export const showHeader = () => ({
    type: "UI/SHOW_HEADER"
});

export const hideHeader = () => ({
    type: "UI/HIDE_HEADER"
});

export const toggleHeader = () => ({
    type: "UI/TOGGLE_HEADER"
});